"use strict";
/**
 * Copyright © 2019 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KsuidUtils = void 0;
const enums_1 = require("../common/enums");
const fox_node_logger_1 = require("@vamstar/fox-node-logger");
const ksuid_1 = __importDefault(require("ksuid"));
const lodash_1 = require("lodash");
/**
 * @description A utility class that exposes static method to sort KSUIDs
 */
class KsuidUtils {
    /**
     *
     * @description A generic method that sorts a list of objects where all the objects have a common field that contains a KSUID
     * @note The method doesn't mutate the argument
     * @param {T[]} arr  An array of list items where all of the array items would have a key that is a KSUID
     * @param {keyof T} key The key of the array item that holds the KSUID value
     * @param {SortDirection} sortDirection Determines the sort direction @default 'ASC'
     * @returns {T[]} A non mutated version of the array in sorted order
     */
    static sortCollection(arr, key, sortDirection = enums_1.SortDirection.ASC) {
        try {
            const clonedArr = (0, lodash_1.cloneDeep)(arr);
            if (sortDirection === enums_1.SortDirection.ASC) {
                return clonedArr.sort((a, b) => ksuid_1.default.parse(a[key]).compare(ksuid_1.default.parse(b[key])));
            }
            return clonedArr.sort((a, b) => ksuid_1.default.parse(b[key]).compare(ksuid_1.default.parse(a[key])));
        }
        catch (error) {
            fox_node_logger_1.log.error(`Error while sorting the list with KSUIDs ... ${error}`);
            throw error;
        }
    }
    /**
     *
     * @description A generic method that sorts a list of KSUIDs and returns a copy of it
     * @note The method doesn't mutate the argument
     * @param {string[]} arr  An array of list items where all of the array items would have a key that is a KSUID
     * @param {SortDirection} sortDirection Determines the sort direction @default 'ASC'
     * @returns {string[]} A non mutated version of the array in sorted order
     */
    static sortList(arr, sortDirection = enums_1.SortDirection.ASC) {
        try {
            const clonedArr = (0, lodash_1.cloneDeep)(arr);
            if (sortDirection === enums_1.SortDirection.ASC) {
                return clonedArr.sort((a, b) => ksuid_1.default.parse(a).compare(ksuid_1.default.parse(b)));
            }
            return clonedArr.sort((a, b) => ksuid_1.default.parse(b).compare(ksuid_1.default.parse(a)));
        }
        catch (error) {
            fox_node_logger_1.log.error(`Error while sorting the list with KSUIDs ... ${error}`);
            throw error;
        }
    }
}
exports.KsuidUtils = KsuidUtils;
//# sourceMappingURL=data:application/json;base64,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